import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { DialogChat } from "./components/DialogChat";
import { DialogsHeader } from "./components/DialogsHeader";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { addStorageObject } from "../../app/state/storageObjectSlice/actions/actions";
import styles from "./styles.module.css";

export const Dialog = () => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("dialogs");
  const { t } = useTranslation();

  const handleAddDialogObject = () => {
    dispatch(
      addStorageObject({
        name: t("dialogs.default_name"),
        service: "dialogs",
        objectType: "child",
      }),
    ).unwrap();
  };

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("dialogs.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={handleAddDialogObject}
      />
    );
  }

  return (
    <div className={styles.container}>
      <DialogsHeader />
      <DialogChat />
    </div>
  );
};
